import { render, staticRenderFns } from "./TablePaginated.vue?vue&type=template&id=d1606430&scoped=true&"
import script from "./TablePaginated.vue?vue&type=script&lang=js&"
export * from "./TablePaginated.vue?vue&type=script&lang=js&"
import style0 from "./TablePaginated.vue?vue&type=style&index=0&id=d1606430&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1606430",
  null
  
)

export default component.exports